import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import classes from "../../intro/pages/style.module.scss";
import StandardToggleButton from "../../elements/buttons/toggle.button.jsx";
import {
  BottomButton,
  BottomButtonContainer,
} from "../../elements/wrapper/bottomButton.wrapper.jsx";
import StandardInstruction from "../../elements/text/standardInstruction.component.jsx";
import ToggleSetting from "../../elements/buttons/toggleSetting.component.jsx";

export default function DataProtection(props) {
  const intl = useIntl();

  const [dp1, setDp1] = useState(props.settings.dp1);
  const [dp2, setDp2] = useState(props.settings.dp2);
  const [dp3, setDp3] = useState(props.settings.dp3);
  const [dp4, setDp4] = useState(props.settings.dp4);

  useEffect(() => {
    const settings = {
      dataProtection: {
        dp1,
        dp2,
        dp3,
        dp4,
      },
    };
    props.setProperties(settings);
  }, [dp1, dp2, dp3, dp4]);

  const settings = [
    {
      name: intl.formatMessage({
        id: "settings.dataProtection.Title1",
      }),
      text: intl.formatMessage({ id: "settings.dataProtection.Text1" }),
      value: dp1,
      set: setDp1,
    },
    {
      name: intl.formatMessage({
        id: "settings.dataProtection.Title2",
      }),
      text: intl.formatMessage({ id: "settings.dataProtection.Text2" }),
      value: dp2,
      set: setDp2,
    },
    {
      name: intl.formatMessage({
        id: "settings.dataProtection.Title3",
      }),
      text: intl.formatMessage({ id: "settings.dataProtection.Text3" }),
      value: dp3,
      set: setDp3,
    },
    {
      name: intl.formatMessage({
        id: "settings.dataProtection.Title4",
      }),
      text: intl.formatMessage({ id: "settings.dataProtection.Text4" }),
      value: dp4,
      set: setDp4,
    },
  ];

  return (
    <div className="d-flex flex-column">
      <StandardInstruction className={"mb-4"}>{props.text}</StandardInstruction>
      <div>
        {settings.map((s, index) => (
          <ToggleSetting
            key={index}
            settingTitle={s.name}
            settingText={s.text}
            onChange={() => s.set((prevState) => !prevState)}
            toggleValue={s.value}
          />
        ))}
      </div>
    </div>
  );
}
